// extracted by mini-css-extract-plugin
export default {"wrapper":"First_wrapper__oaMGr","bg":"First_bg__H+twS","content":"First_content__PGJwc","title":"First_title__OS+q8","desc":"First_desc__JpNlF"};